/**
 * Slider Component
 *
 * @file lightbox.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
// import "https://cdn.jsdelivr.net/npm/@fancyapps/ui/dist/fancybox.css";

const loadFancyboxCSS = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@5.0/dist/fancybox/fancybox.css';
  document.head.appendChild(link);

  // Özel stil ekle
  const style = document.createElement('style');
  style.textContent = `
    .fancybox__backdrop {
      background-color: rgba(255, 255, 255, 1) !important;
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);
};

const lightbox = (() => {

  const homeLightbox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Fancybox ayarlarını buraya ekleyebilirsiniz
    });   
    Fancybox.bind('[data-fancybox="product-gallery"]', {
    });   
    loadFancyboxCSS(); // CSS dosyasını dinamik olarak yükle
  }

  const productStoryPopup = () => {
    document.addEventListener('DOMContentLoaded', function() {
      var productStory = document.querySelector('.product-story-of-carpet');
    
      document.querySelectorAll('.story-carpet-popup').forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
          event.preventDefault();
          if (productStory) {
            productStory.classList.add('active');
            document.documentElement.classList.add('hidden');
            document.body.classList.add('hidden');
          }
        });
      });
    
      document.querySelectorAll('.story-close').forEach(function(closeAnchor) {
        closeAnchor.addEventListener('click', function(event) {
          if (productStory) {
            productStory.classList.remove('active');
            document.documentElement.classList.remove('hidden');
            document.body.classList.remove('hidden');
          }
        });
      });
    });
  }

  const pageContactModal = () => {
    document.addEventListener('DOMContentLoaded', function() {
      var contactBlModal = document.querySelector('.contact-bl-modal ');
    
      document.querySelectorAll('.ht-contact').forEach(function(anchor) {
        anchor.addEventListener('click', function(event) {
          event.preventDefault();
          if (contactBlModal) {
            contactBlModal.classList.add('active');
            document.body.classList.add('hidden');
          }
        });
      });
    
      document.querySelectorAll('.contact-bl-modal-close').forEach(function(closeAnchor) {
        closeAnchor.addEventListener('click', function(event) {
          if (contactBlModal) {
            contactBlModal.classList.remove('active');
            document.body.classList.remove('hidden');
          }
        });
      });
    });
  }

  const tooltipSh = () => {
    document.addEventListener('DOMContentLoaded', function() {
      const tooltipTrigger = document.querySelector('.tooltip-sh');
  
      // tooltip-sh sınıfı varsa çalışsın
      if (tooltipTrigger) {
          const tooltip = document.createElement('div');
          tooltip.className = 'pg-custom-tooltip';
          document.body.appendChild(tooltip);
  
          tooltipTrigger.addEventListener('mouseenter', function(event) {
              const tooltipText = tooltipTrigger.getAttribute('data-tooltip');
              tooltip.textContent = tooltipText;
              tooltip.classList.add('active');
          });
  
          tooltipTrigger.addEventListener('mousemove', function(event) {
              tooltip.style.left = event.pageX + 20 + 'px';
              tooltip.style.top = event.pageY + 20 + 'px';
          });
  
          tooltipTrigger.addEventListener('mouseleave', function() {
              tooltip.classList.remove('active');
          });
      }
    });
  }

  const productTooltipSh = () => {
    document.querySelectorAll('.tooltip-pr-sh').forEach((button) => {
      const tooltipText = button.getAttribute('data-tooltip');
      
      if (tooltipText) {
        const tooltip = document.createElement('div');
        tooltip.className = 'product-tooltip';
        tooltip.textContent = tooltipText;
        button.appendChild(tooltip);
    
        button.addEventListener('mouseenter', () => {
          tooltip.style.display = 'block';
        });
    
        button.addEventListener('mouseleave', () => {
          tooltip.style.display = 'none';
        });
      }
    });
  }

  const homeLoadModal = () => {
    // document.addEventListener("DOMContentLoaded", function () {
    //   var modalContent = document.querySelector("#campaing-modal-content");
      
    //   if (modalContent) {
    //     Fancybox.show([{
    //         src: "#campaing-modal-content", 
    //         type: "inline"
    //     }]);
    //   }
    // });
  }

  const bannerScrollBottom = () => {
    const scrollButton = document.querySelector('.banner-scroll-bottom');
    if (scrollButton) { 
      scrollButton.addEventListener('click', function() {
        const aboutBanner = document.querySelector('.about-banner, .home-full-slide');
        if (aboutBanner) {
          const nextElement = aboutBanner.nextElementSibling;
          if (nextElement) {
            nextElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    }
  }

  const init = () => {
    homeLoadModal();
    homeLightbox();
    productStoryPopup();
    pageContactModal();
    tooltipSh();
    productTooltipSh();
    bannerScrollBottom();
  };

  return {
    init,
  };
})();

export default lightbox;
